export const portalData = {
  // Fax Details
  hasFax: false,
  faxNo: "",
  
  // Whatsapp details
  hasWhatsApp: true,
  whatsAppNo: "+6014-9420566",
  whatsAppNoHolderName: "Nurul",
  hasAltWhatsApp: false,
  altWhatsAppNo: "+6012-9698013",
  altWhatsAppNoHolderName: "Jay Tang",
  hasAltWhatsApp1: false,
  altWhatsAppNo1: "",
  altWhatsAppNoHolderName1: "",
  hasAltWhatsApp2: false,
  altWhatsAppNo2: "",
  altWhatsAppNoHolderName2: false,
  
  // Phone number details
  hasPhoneNo: true,
  phoneNo: "+6014-9420566",
  hasAltPhoneNo: false,
  altPhoneNo: "",
  
  // Telephone number details
  hasTellNo: true,
  tellNo: "+6014-9420566",
  tellNoHolderName: "Nurul",
  hasAltTellNo: true,
  altTellNo: "+6012-9698013",
  altTellNoHolderName: "Jay Tang",
  hasAltTellNo2: false,
  altTellNo2: "",
  altTellNoHolderName2: "",
  
  // Portal information details
  portalNameXSpace: "Horizon Sea Resort",
  portalName: "Horizon Sea Resort",
  portalFullName: "Horizon Sea Resort",
  portalFullNameUppercase: "HORIZON SEA RESORT",
  portalShortAddress: "Block A, Lot 4, 2nd Floor",
  portalAddress: "Seafront New Township, Block A, Lot 4, 2nd Floor, Semporna 91307 Sabah, Malaysia.",
  portalAddressFirstPart: "Seafront New Township, Block A, Lot 4, 2nd Floor,",
  portalAddressSecondPart: "Semporna 91307 Sabah, Malaysia.",
  portalAddressDetails: "Seafront New Township, Block A, Lot 4, 2nd Floor, Semporna 91307 Sabah, Malaysia.",
  hasPortalRegNo: true,
  portalRegNo: "988250-A, KPL/LN: 6901",
  
  // Portal Bank Details
  portalBankName: "Malayan Banking Berhad",
  portalBankAddress: "",
  portalBankAccHolderName: "Scubaholics Sdn Bhd",
  portalBankAccNo: "5601 4866 4547",
  hasPortalBankSwiftCode: true,
  portalBankSwiftCode: "",
   
  portalEmail: "sales@horizonsearesort.com.my",
  portalTermAndCondUrl: process.env.REACT_APP_PORTAL_TERM_AND_COND_URL,   
  appName: "Island Resort Centralised Reservation Platform",

  // GST details
  hasGst: false,
  gstNo: true,
   
  // Website
  portalWebsite: process.env.REACT_APP_PORTAL_WEBSITE,
 
  // Travoxis Website
  travoxisWebsite: process.env.REACT_APP_TRAVOXIS_WEBSITE,
 
  // Facebook page link
  facebookMessengerLink: "https://www.facebook.com/",
 
  // portal S3 base url
  s3AwsUrl: "",
 
  adminPortalUrl: process.env.REACT_APP_ADMIN_PORTAL_URL,

  // Portal Jetty names
  jettyOne: "Tourist Jetty",
  jettyTwo: "Jalan Bangau-Bangau Semporna",
  jettyThree: "",
  jettyOneToTwoTime: "09:00 AM",
  jettyTwoToOneTime: "02:00 PM",
  portalAdminUrl: process.env.REACT_APP_ADMIN_PORTAL_URL,
  fromLocation: "",
}  